import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalBaseComponent } from '../../components/modal-base/modal-base.component';
import { ModalHostDirective } from '../../directives/modal-host.deirective';
import { DashboardUsersModalComponent } from '../dashboard/dashboard-users-modal/dashboard-users-modal.component';
import { CommonComponentsModule } from '../../common-components.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    CommonComponentsModule,
    FormsModule
  ],
  declarations: [
    ModalHostDirective,
    ModalBaseComponent,
    DashboardUsersModalComponent,
  ],
  exports: [
    ModalHostDirective,
    ModalBaseComponent,
    DashboardUsersModalComponent,
  ],
  entryComponents: [
    DashboardUsersModalComponent
  ]
})
export class AppModalModule {
}



// WEBPACK FOOTER //
// /app/src/app/views/modal/app-modal.module.ts